import cs from 'classnames';
import Link from 'next/link';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useMemo, useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import { Box } from '@/DesignSystem/Component';
import { useShadUser } from '@/Module/Auth/Hook';
import { LINKS } from '@/Module/Core/Constant';
import { IconClose, IconContact, IconKeySquare } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
interface IMiniAccountMenuProps {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}
const MiniAccountMenu: FC<IMiniAccountMenuProps> = ({
  isOpen,
  setOpen
}) => {
  const ref = useRef(null);
  const isShadUser = useShadUser();
  const person = useAppSelector(state => state.auth.person);
  const fullName = useMemo(() => {
    if (!person) return 'میهمان';
    if (!person.name && !person.family) return 'پروفایل تکمیل نشده است';
    return `${person.name ?? ''} ${person.family ?? ''}`;
  }, [person?.name, person?.family]);
  useOnClickOutside(ref, () => {
    setOpen(false);
  });
  return <Box ref={ref} color="primaryMiddle" className={cs('absolute left-0 lg:left-48 xl:left-72 mt-2 w-[280px] transition-all border-4 border-blueThree  text-black z-50', 'before:absolute before:bottom-full before:left-3  before:border-x-[8px] before:border-b-[10px] before:border-x-transparent before:border-b-blueThree ', isOpen ? 'top-full opacity-100 visible' : 'top-[120%] opacity-0 invisible')} data-sentry-element="Box" data-sentry-component="MiniAccountMenu" data-sentry-source-file="MiniAccountMenu.tsx">
      <ul>
        <li className="border-b border-b-gray-300 px-6 py-4 font-bold">{fullName}</li>
        <li className="transition-al border-b border-b-gray-300 hover:bg-gray-100">
          <Link className="flex items-center gap-4 px-6 py-4" href={LINKS.PROFILE.SUBSCRIPTION} data-sentry-element="Link" data-sentry-source-file="MiniAccountMenu.tsx">
            <IconKeySquare className="text-blueThree " size="small" data-sentry-element="IconKeySquare" data-sentry-source-file="MiniAccountMenu.tsx" />
            <span>اشتراک‌های من</span>
          </Link>
        </li>
        <li className="transition-al border-b border-b-gray-300 hover:bg-gray-100">
          <Link className="flex items-center gap-4 px-6 py-4" href={LINKS.PROFILE.DEFAULT} data-sentry-element="Link" data-sentry-source-file="MiniAccountMenu.tsx">
            <IconContact className="text-blueThree " size="small" data-sentry-element="IconContact" data-sentry-source-file="MiniAccountMenu.tsx" />
            <span>آی‌نـوی من</span>
          </Link>
        </li>
        {!isShadUser && <li className="transition-all hover:bg-gray-100">
            <Link className="flex items-center gap-4 px-6 py-4" href={LINKS.AUTH.LOGOUT}>
              <IconClose className="text-blueThree " size="small" />
              <span>خروج</span>
            </Link>
          </li>}
      </ul>
    </Box>;
};
export default MiniAccountMenu;